import { createContext } from 'react';
const MomContext = createContext();
export default MomContext;
